import { create } from 'zustand';

type InboxQuestionGroupCardsState = {
  /** Inquiry group keys the reader has toggled, true for open. An inquiry group not listed starts collapsed. */
  expandedByKey: Record<string, boolean>;
  setExpanded: (questionGroupKey: string, expanded: boolean) => void;
  reset: () => void;
};

/**
 * Which staff inquiry group cards are expanded, kept outside the card so the choice survives opening a
 * conversation and coming back. A list row can unmount while it is scrolled away or while the chat
 * covers the inbox, and local state would collapse every inquiry group on return.
 *
 * In-memory on purpose: a cold start shows every inquiry group collapsed.
 */
export const useInboxQuestionGroupCardsStore = create<InboxQuestionGroupCardsState>((set) => ({
  expandedByKey: {},
  setExpanded: (questionGroupKey, expanded) =>
    set((state) => ({ expandedByKey: { ...state.expandedByKey, [questionGroupKey]: expanded } })),
  reset: () => set({ expandedByKey: {} }),
}));
